import { type Event, Fit, Layout, Rive, type RiveFile } from "@rive-app/canvas";
import { loadAndCacheRiveFile } from "./rive";

const bootRiveInstance = (file: RiveFile, containers: NodeListOf<HTMLCanvasElement>) => {
  containers.forEach((itemCanva) => {
    const rive = new Rive({
      riveFile: file,
      canvas: itemCanva,
      autoplay: true,
      layout: new Layout({
        fit: Fit.Cover,
      }),
      onLoad: () => {
        computeSize();
      },
    });

    function computeSize() {
      rive.resizeDrawingSurfaceToCanvas();
    }

    // Subscribe to window size changes and update call `resizeDrawingSurfaceToCanvas`
    window.onresize = computeSize;
    // Subscribe to devicePixelRatio changes and call `resizeDrawingSurfaceToCanvas`
    window
      .matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
      .addEventListener("change", computeSize);
  });
};

export const initRiveAnimations = () => {
  const allRive = [
    {
      src: "/inc/assets/main_assets/rive/barry-add-video.riv",
      element: ".rive-barry-add-video",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-confetti.riv",
      element: ".rive-barry-confetti",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-hello.riv",
      element: ".rive-barry-hello",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-no-bookings.riv",
      element: ".rive-barry-no-bookings",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-no-conversations.riv",
      element: ".rive-barry-no-conversations",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-no-favorites.riv",
      element: ".rive-barry-no-favorites",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-no-internet.riv",
      element: ".rive-barry-no-internet",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-not-logged-in.riv",
      element: ".rive-barry-not-logged-in",
    },
    {
      src: "/inc/assets/main_assets/rive/barry-oops.riv",
      element: ".rive-barry-oops",
    },
    {
      src: "/inc/assets/main_assets/rive/map-loader.riv",
      element: ".rive-map-loader",
    },
  ];

  allRive.forEach((item) => {
    const containers: NodeListOf<HTMLCanvasElement> = document.querySelectorAll(item.element);

    if (containers.length > 0) {
      loadAndCacheRiveFile(
        item.src,
        (file: RiveFile) => {
          bootRiveInstance(file, containers);
        },
        (event: Event) => {
          console.error("Failed to load Rive file:", event);
        },
      );
    }
  });
};
